const DefendantNameCell = ({
    caseData
}) => {

    return (
        <>
            {caseData.defendants?.map((c, i) => (
                <div key={i}>{c.personalInfo.name}</div>
            ))}
        </>
    );
};

export default DefendantNameCell;
